import React, { useState, useEffect } from 'react';
import Wager from './Wager';
import Table from '../components/Table';
import Rules from '../components/Rules';
import './Game.css';

import firebase from '../firebase';

export default function Game({ setStage, setLeaderboard, money, setMoney, name }) {

  const suits = ['Spades', 'Clubs', 'Hearts', 'Diamonds'];
  const deckStatic = [
    0, 1, 2, 3, 4, 5, 6, 7, 8,
    9, 10, 11, 12, 13, 14, 15,
    16, 17, 18, 19, 20, 21, 22,
    23, 24, 25, 26, 27, 28, 29,
    30, 31, 32, 33, 34, 35, 36,
    37, 38, 39, 40, 41, 42, 43,
    44, 45, 46, 47, 48, 49, 50,
    51,
  ];
  const [numDecks] = useState(3);
  const [deck, setDeck] = useState(shuffle());
  const [dealerCards, setDealerCards] = useState([]);
  const [playerCards, setPlayerCards] = useState([]);
  const [dealerVal, setDealerVal] = useState(0);
  const [playerVal, setPlayerVal] = useState(0);
  const [wagerAmount, setWagerAmount] = useState(0);

  // Keep track if user clicked show rules
  const [showRules, setShowRules] = useState(false);
  const [endOfRound, setEndOfRound] = useState(false);
  const [dealt, setDealt] = useState(false);
  const [playerDone, setPlayerDone] = useState(false);
  const [overlay, setOverlay] = useState('');

  useEffect(() =>{
    if(endOfRound) {
      let textVal;
      let wins = 0;

      if (is493Jack(playerCards) && !is493Jack(dealerCards)) {
        textVal = 'You Win! $' + (wagerAmount * 5).toString();
        wins = wagerAmount * 6;
      } else if (!is493Jack(playerCards) && is493Jack(dealerCards)) {
        textVal = 'Dealer Wins!';
      } else if ((playerVal > dealerVal && playerVal <= 21) || dealerVal > 21) {
        textVal = 'You Win! $' + wagerAmount.toString();
        wins = wagerAmount * 2;
      }else if (playerVal === dealerVal) {
        textVal = 'Tie';
        wins = wagerAmount;
      }else {
        textVal = 'Dealer Wins!';
      }

      setMoney(prev => prev + wins)
      setTimeout(() => {
        reset(wins);
      }, 2000);

      setOverlay(
        <div className="game-overlay">
          <div className="game-overlay-text">
            {textVal}
          </div>
        </div>
      );
      }
    else {
      setOverlay('');
    }
    // eslint-disable-next-line
  }, [endOfRound])

  useEffect(()=> {
    let val = calculateHandValue(playerCards);
    setPlayerVal(val);
  }, [playerCards]);

  useEffect(() => {
    if (playerVal > 21) {
      flipDealersCard();
      setTimeout(() => {
        setEndOfRound(true);
      }, 1000);
    }
    // eslint-disable-next-line
  }, [playerVal]);

  useEffect(()=> {
    let val = calculateHandValue(dealerCards);
    if (dealerVal === val) {
      checkIfDealerDone();
    }

    setDealerVal(val);
    // eslint-disable-next-line
  }, [dealerCards]);

  useEffect(() => {
    checkIfDealerDone();
    // eslint-disable-next-line
  }, [dealerVal]);

  function checkIfDealerDone() {
    if (playerDone) {
      setTimeout(() => {
        if (dealerVal < playerVal && !is493Jack(dealerCards)) {
          dealCardToDealer(true);
        } else {
          setTimeout(() => {
            setEndOfRound(true);
          }, 1000);
        }
      }, 1000);
    }
  }

  function hit() {
    dealCardToPlayer();
  }

  function stand() {
    flipDealersCard();
    setPlayerDone(true);
  }

  function flipDealersCard() {
    let dealerHand = [...dealerCards];
    dealerHand[0].faceUp = true;
    setDealerCards(dealerHand);
  }

  function reset(wins) {
    setDealt(false);
    setEndOfRound(false);
    setPlayerDone(false);
    setPlayerVal(0);
    setDealerVal(0);
    setPlayerCards([]);
    setDealerCards([]);
    setWagerAmount(0);

    if (money === 0 && wins === 0) setStage('gameover');
  }

  function shuffle() {
    let tempDeck = [];
    for (let i = 0; i < numDecks; ++i)
      tempDeck = tempDeck.concat(deckStatic);

    // Fisher-Yates shuffle algorithm
    for (let i = tempDeck.length - 1; i >= 0; --i)
    {
      let r = Math.floor(Math.random() * i);
      let temp = tempDeck[i];
      tempDeck[i] = tempDeck[r];
      tempDeck[r] = temp;
    }

    return tempDeck;
  }

  function dealCardToPlayer() {
    let card = deck.shift();
    let suit = suits[card % 4];

    let cardObj = {
      card: card,
      suit: suit,
      faceUp: true,
    };

    setPlayerCards(prev => [...prev, cardObj]);
  }

  function dealCardToDealer(faceUp) {
    let card = deck.shift();
    let suit = suits[card % 4];

    let cardObj = {
      card: card,
      suit: suit,
      faceUp: faceUp,
    };

    setDealerCards(prev => [...prev, cardObj]);
  }

  function calculateHandValue(hand) {
    let val = 0;

    // add all non ace cards
    for (let i = 0; i < hand.length; i++) {
      if (!hand[i].faceUp) continue;
      let card = hand[i].card;
      let ace = (Math.floor(card / 4) === 0) ? true : false;
      if (ace) continue;
      let cardVal;
      if (Math.floor(card / 4) < 9) {
        // 2 through 9
        cardVal = Math.floor(card / 4) + 1;
      }else {
        // 10, Jack, Queen, or King
        cardVal = 10;
      }

      val += cardVal;
    }

    // add all ace cards as 1
    for (let i = 0; i < hand.length; i++) {
      if (!hand[i].faceUp) continue;
      let card = hand[i].card;
      let ace = (Math.floor(card / 4) === 0) ? true : false;
      if (!ace) continue;
      val += 1;
    }

    // for first ace add 10 if doesn't cause bust
    for (let i = 0; i < hand.length; i++) {
      if (!hand[i].faceUp) continue;
      let card = hand[i].card;
      let ace = (Math.floor(card / 4) === 0) ? true : false;
      if (!ace) continue;
      if (val + 10 <= 21) {
        val += 10;
      }

      break;
    }

    return val;
  }

  function deal(wager) {
    setWagerAmount(wager);
    setDealerCards([]);
    setPlayerCards([]);
    setPlayerVal(0);
    setDealerVal(0);
    setDealt(true);
    setMoney(money - wager);
    if (deck.length < 0.5 * (numDecks * deckStatic.length))
      setDeck(shuffle());

    dealCardToPlayer();
    dealCardToDealer(false);
    dealCardToPlayer();
    dealCardToDealer(true);
  }

  function renderWagerComponents() {
    if (dealt === false) {
      return (
          <Wager startMoney={money}
              callback={deal}>
          </Wager>
      );
    }else {
      return;
    }
  }

  function renderGameOptions() {
    if (dealt === true) {
      return (
        <div className="game-options">
          <button
            className="game-hit"
            onClick={hit}>
              Hit
          </button>
          <button
            className="game-stand"
            onClick={stand}>
              Stand
          </button>
        </div>
      );
    }else {
      return;
    }
  }

  function is493Jack(cards) {
    if (cards.length !== 3) return false;
    let has4 = (cards[0].card / 4 === 3 || cards[1].card / 4 === 3 || cards[2].card / 4 === 3);
    let has9 = (cards[0].card / 4 === 8 || cards[1].card / 4 === 8 || cards[2].card / 4 === 8);
    let has3 = (cards[0].card / 4 === 2 || cards[1].card / 4 === 2 || cards[2].card / 4 === 2);
    if (has4 && has9 && has3) return true;
    return false;
  }

  // function renderEndOfRound() {
  //   let textVal;
  //   let wins = 0;
  //
  //   if (is493Jack(playerCards) && !is493Jack(dealerCards)) {
  //     textVal = 'You Win! $' + (wagerAmount * 5).toString();
  //     wins = wagerAmount * 6;
  //   } else if (!is493Jack(playerCards) && is493Jack(dealerCards)) {
  //     textVal = 'Dealer Wins!';
  //   } else if ((playerVal > dealerVal && playerVal <= 21) || dealerVal > 21) {
  //     textVal = 'You Win! $' + wagerAmount.toString();
  //     wins = wagerAmount * 2;
  //   }else if (playerVal === dealerVal) {
  //     textVal = 'Tie';
  //     wins = wagerAmount;
  //   }else {
  //     textVal = 'Dealer Wins!';
  //   }
  //
  //   return (
  //     <div className="game-overlay" onClick={() => {
  //         reset(wins); setMoney(prev => prev + wins);
  //       }
  //     }>
  //       <div className="game-overlay-text">
  //         {textVal}
  //       </div>
  //     </div>
  //   );
  // }

  // Handle user clicks on rules
  function renderRules() {
    // Function to pass into Rules component to handle user closes rules popup
    function handleDiscardRules(stage) {
      if (stage === 'home') setShowRules(false);
    }

    if (showRules) {
      return (
        <Rules setDisplay={handleDiscardRules} />
      );
    }
  }

  // Handle leave game
  function handleLeave() {
    if (window.confirm('Are you sure you want to quit? Your money will reset to $100 the next time you play.')) {
      // Add name and money to database
      firebase.database().ref('leaderboard/' + name).set(money);

      // Advance to end page
      setStage('leavegame');
    }
  }

  // {(endOfRound) && renderEndOfRound()}
  return (
    <div className="game-container">
      {overlay}
      <div className="game-content">
        <div className="game-top">
          <div className="money-display">Money: {money}</div>
          <div>
            <button className="game-leave" onClick={handleLeave}>
              <i className='fa fa-sign-out'></i> Leave
            </button>
            <button className="game-rules" onClick={() => setShowRules(true)}>
              <i className='fa fa-question-circle'></i> Rules
            </button>
          </div>
        </div>
          <Table
            dealerCards={dealerCards}
            dealerVal={dealerVal}
            playerCards={playerCards}
            playerVal={playerVal}
            money={money}
            is493Jack={is493Jack}
          />
          {renderWagerComponents()}
          {renderGameOptions()}
          <div className='game-rules-container'>{renderRules()}</div>
      </div>
    </div>
  );
}
